import {rpAppLink} from "@pg-mono/rp-routes";

import {ArticleCategory, getSlugByArticleCategory} from "../../actions/ArticleCategory";

const lawAndDocs360x228 = require("./assets/law_and_documents_360x228.png");
const lawAndDocs552x228 = require("./assets/law_and_documents_552x228.png");

const creditAndFinance360x228 = require("./assets/credit_and_finance_360x228.png");
const creditAndFinance552x228 = require("./assets/credit_and_finance_552x228.png");

const marketTrends360x228 = require("./assets/market_trends_360x228.png");
const marketTrends744x228 = require("./assets/market_trends_744x228.png");

const getCategoryUrl = (category: ArticleCategory) => rpAppLink.article.category({categorySlug: getSlugByArticleCategory(category)});

export const getSeeMoreArticleCategories = (categories: (ArticleCategory.Taxes | ArticleCategory.Reports | ArticleCategory.Finance)[]) => {
    const seeMoreCategories = {
        [ArticleCategory.Taxes]: {
            key: ArticleCategory.Taxes,
            url: getCategoryUrl(ArticleCategory.Taxes),
            sources: [
                {minWidthPX: 0, src: lawAndDocs360x228, height: 228, width: 360},
                {minWidthPX: 1024, src: lawAndDocs552x228, height: 228, width: 552}
            ],
            titleText: "Prawo i dokumenty"
        },
        [ArticleCategory.Reports]: {
            key: ArticleCategory.Reports,
            url: getCategoryUrl(ArticleCategory.Reports),
            sources: [
                {minWidthPX: 0, src: marketTrends360x228, height: 228, width: 360},
                {minWidthPX: 1024, src: marketTrends744x228, height: 228, width: 744}
            ],
            titleText: "Raporty i dane rynkowe"
        },

        [ArticleCategory.Finance]: {
            key: ArticleCategory.Finance,
            url: getCategoryUrl(ArticleCategory.Finance),
            sources: [
                {minWidthPX: 0, src: creditAndFinance360x228, height: 228, width: 360},
                {minWidthPX: 1024, src: creditAndFinance552x228, height: 228, width: 552}
            ],
            titleText: "Kredyty i finanse"
        }
    };
    return categories.map((category) => seeMoreCategories[category]);
};
